import { ThematicIcon } from '@services';
import { AiFillIdcard, AiFillSound } from 'react-icons/ai';
import { BiSolidBarChartAlt2, BiSolidChat, BiSolidMessageAltError } from 'react-icons/bi';
import { BsBuildingsFill, BsClipboard2CheckFill, BsConeStriped, BsPersonFillExclamation } from 'react-icons/bs';
import { FaBalanceScaleRight, FaFlagCheckered, FaGraduationCap, FaLeaf, FaRoad, FaShoppingCart, FaUmbrellaBeach } from 'react-icons/fa';
import { FaHelmetSafety, FaPersonFalling, FaRepeat, FaTriangleExclamation } from 'react-icons/fa6';
import { HiClipboardDocumentList, HiMiniDocumentMagnifyingGlass, HiMiniWrenchScrewdriver } from 'react-icons/hi2';
import { IoBagHandleSharp, IoBuild, IoLibrary, IoPersonAddSharp, IoShieldCheckmarkSharp } from 'react-icons/io5';
import { MdFactory, MdTimer } from 'react-icons/md';
import { PiLadderBold, PiListChecksFill, PiMedalFill } from 'react-icons/pi';
import { RiStackFill } from 'react-icons/ri';
import { TiFlash } from 'react-icons/ti';

type ThematicsIconProviderProps = {
    icon: ThematicIcon;
};

export const ThematicsIconProvider: React.FC<ThematicsIconProviderProps> = ({ icon }) => {
    let iconComponent = null;

    switch (icon) {
        case 'card':
            iconComponent = <AiFillIdcard />;
            break;
        case 'road':
            iconComponent = <FaRoad />;
            break;
        case 'ladder':
            iconComponent = <PiLadderBold />;
            break;
        case 'falling':
            iconComponent = <FaPersonFalling />;
            break;
        case 'flash':
            iconComponent = <TiFlash />;
            break;
        case 'sound':
            iconComponent = <AiFillSound />;
            break;
        case 'barchart':
            iconComponent = <BiSolidBarChartAlt2 />;
            break;
        case 'chat':
            iconComponent = <BiSolidChat />;
            break;
        case 'message-error':
            iconComponent = <BiSolidMessageAltError />;
            break;
        case 'buildings':
            iconComponent = <BsBuildingsFill />;
            break;
        case 'clipboard1':
            iconComponent = <BsClipboard2CheckFill />;
            break;
        case 'cone':
            iconComponent = <BsConeStriped />;
            break;
        case 'person':
            iconComponent = <BsPersonFillExclamation />;
            break;
        case 'balance':
            iconComponent = <FaBalanceScaleRight />;
            break;
        case 'flag':
            iconComponent = <FaFlagCheckered />;
            break;
        case 'cap':
            iconComponent = <FaGraduationCap />;
            break;
        case 'helmet':
            iconComponent = <FaHelmetSafety />;
            break;
        case 'leaf':
            iconComponent = <FaLeaf />;
            break;
        case 'repeat':
            iconComponent = <FaRepeat />;
            break;
        case 'cart':
            iconComponent = <FaShoppingCart />;
            break;
        case 'triangle':
            iconComponent = <FaTriangleExclamation />;
            break;
        case 'beach':
            iconComponent = <FaUmbrellaBeach />;
            break;
        case 'doclist':
            iconComponent = <HiClipboardDocumentList />;
            break;
        case 'magnifying':
            iconComponent = <HiMiniDocumentMagnifyingGlass />;
            break;
        case 'wrench':
            iconComponent = <HiMiniWrenchScrewdriver />;
            break;
        case 'bag':
            iconComponent = <IoBagHandleSharp />;
            break;
        case 'build':
            iconComponent = <IoBuild />;
            break;
        case 'library':
            iconComponent = <IoLibrary />;
            break;
        case 'personsharp':
            iconComponent = <IoPersonAddSharp />;
            break;
        case 'shieldcheck':
            iconComponent = <IoShieldCheckmarkSharp />;
            break;
        case 'factory':
            iconComponent = <MdFactory />;
            break;
        case 'timer':
            iconComponent = <MdTimer />;
            break;
        case 'listchecks':
            iconComponent = <PiListChecksFill />;
            break;
        case 'medal':
            iconComponent = <PiMedalFill />;
            break;
        case 'stack':
            iconComponent = <RiStackFill />;
            break;
        default:
            iconComponent = null;
    }

    return iconComponent;
};
